export const YANDEX_MAP_API_KEY = "67d10f03-4ba3-431d-a737-d8262d467f2f";
export const YANDEX_MAP_API_VERSION = "2.1";
export const YANDEX_MAP_API_LANG = "ru_RU";
